import { apiInterfaceForJson } from "../common/apiManager";

export const fetchCampaigns = () => {
    return apiInterfaceForJson("/campaign/v1/", "GET");
};

export const getCampaignById = (campaignId) => {
    return apiInterfaceForJson(`/campaign/v1/${campaignId}`, "GET");
};

export const fetchCampaignCalls = (campaignId, { page = 1, limit = 50, status, minDuration, maxDuration } = {}) => {
    const params = new URLSearchParams({ page, limit });
    if (status) params.append("status", status);
    if (minDuration) params.append("minDuration", minDuration);
    if (maxDuration) params.append("maxDuration", maxDuration);
    return apiInterfaceForJson(`/campaign/v1/${campaignId}/calls?${params.toString()}`, "GET");
};

export const previewAudience = (filters, range = null) => {
    return apiInterfaceForJson("/campaign/v1/preview-audience", "POST", { filters, range });
};

export const createCampaign = (campaignData) => {
    return apiInterfaceForJson("/campaign/v1/", "POST", campaignData);
};

export const startCampaign = (campaignId) => {
    return apiInterfaceForJson(`/campaign/v1/${campaignId}/start`, "POST");
};

export const pauseCampaign = (campaignId) => {
    return apiInterfaceForJson(`/campaign/v1/${campaignId}/pause`, "POST");
};

export const cancelCampaign = (campaignId) => {
    return apiInterfaceForJson(`/campaign/v1/${campaignId}/cancel`, "POST");
};

export const removeCampaignCalls = (campaignId, { callIds, newLeadStatus } = {}) => {
    return apiInterfaceForJson(`/campaign/v1/${campaignId}/calls/remove`, "POST", { callIds, newLeadStatus });
};

export const rerunCampaign = (campaignId) => {
    return apiInterfaceForJson(`/campaign/v1/${campaignId}/rerun`, "POST");
};

export const deleteCampaign = (campaignId) => {
    return apiInterfaceForJson(`/campaign/v1/${campaignId}`, "DELETE");
};

export const updateCampaignSettings = (campaignId, settings) => {
    return apiInterfaceForJson(`/campaign/v1/${campaignId}/settings`, "PATCH", settings);
};

export const startTestCall = ({ agentId, fromNumber, leadId }) => {
    return apiInterfaceForJson("/campaign/v1/test-call", "POST", { agentId, fromNumber, leadId });
};

export const getCampaignCallById = (callId) => {
    return apiInterfaceForJson(`/campaign/v1/calls/${callId}`, "GET");
};

// AI analysis of a real campaign call can take a while (large multi-state
// prompts) — use a 5 minute timeout, same as the AI Agents test-call flow.
const AI_TIMEOUT = 300000;

export const analyzeCampaignCall = (callId) => {
    return apiInterfaceForJson(`/campaign/v1/calls/${callId}/analyze`, "POST", undefined, undefined, AI_TIMEOUT);
};

export const generateCampaignCallFix = (callId, findingIndexes) => {
    return apiInterfaceForJson(`/campaign/v1/calls/${callId}/fix`, "POST", { findingIndexes }, undefined, AI_TIMEOUT);
};

export const fetchLiveCalls = () => {
    return apiInterfaceForJson("/campaign/v1/live-calls", "GET");
};

export const stopLiveCall = (callId) => {
    return apiInterfaceForJson(`/campaign/v1/live-calls/${callId}/stop`, "POST");
};

export const fetchCallResults = ({ page = 1, limit = 50, tags, campaignId, reviewed, minDuration, maxDuration } = {}) => {
    const params = new URLSearchParams({ page, limit });
    if (tags && tags.length) params.append("tags", Array.isArray(tags) ? tags.join(",") : tags);
    if (campaignId) params.append("campaignId", campaignId);
    if (reviewed !== undefined && reviewed !== null && reviewed !== "") params.append("reviewed", reviewed);
    if (minDuration) params.append("minDuration", minDuration);
    if (maxDuration) params.append("maxDuration", maxDuration);
    return apiInterfaceForJson(`/campaign/v1/results?${params.toString()}`, "GET");
};

export const setCallReviewed = (callId, reviewed = true) => {
    return apiInterfaceForJson(`/campaign/v1/results/${callId}/review`, "POST", { reviewed });
};

export const fetchRetellAgents = () => {
    return apiInterfaceForJson("/campaign/v1/retell/agents", "GET");
};

export const fetchRetellPhoneNumbers = () => {
    return apiInterfaceForJson("/campaign/v1/retell/phone-numbers", "GET");
};

// ── Self-service: campaigns where the logged-in user is the transfer agent ──
export const fetchMyCampaigns = () => {
    return apiInterfaceForJson("/campaign/v1/mine", "GET");
};

export const startMyCampaign = (campaignId) => {
    return apiInterfaceForJson(`/campaign/v1/mine/${campaignId}/start`, "POST");
};

export const pauseMyCampaign = (campaignId) => {
    return apiInterfaceForJson(`/campaign/v1/mine/${campaignId}/pause`, "POST");
};

export const updateMyCampaignConcurrency = (campaignId, concurrencyLimit) => {
    return apiInterfaceForJson(`/campaign/v1/mine/${campaignId}/concurrency`, "PATCH", { concurrencyLimit });
};
